import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';
import {Box, Typography, Theme} from '@mui/material';
import {CustomButton} from '@buttons/CustomButton';
import TagManager from 'react-gtm-module';
import {useSelectedQuoteStore} from '@store/QuoteStore';
import {useCarStore} from '@store/carInfoStore';
import {useDriverStore} from '@store/driverInfoStore';
import {useGetQuotePayment} from '@store/QuoteData';
import {upCRM} from '@utils/CRM';
import {useTokenStore} from '@store/TokenStore';
import {useTrackingStore} from '@store/TrackingStore';
import {usePolicyStore} from '@store/policyStore';
import {useCPStore} from '@store/cpStore';
import {useCarListStore} from '@store/carListStore';
import {getTracking} from '@api/getTracking';
import {OrderSelect} from './OrderSelect';
import {selectedInsurer} from '@api/features';
import ReactTooltip from 'react-tooltip';
import {makeStyles} from '@mui/styles';
import Info from '@mui/icons-material/Info';
import {useClamp} from '@utils/useClamp';
import GenericModal from "@modals/ModalAmpliaIntegral/GenericModal";
import {getInsurers} from "@modals/ModalAmpliaIntegral/utils";
import {useCopyQuoteStore} from "@store/copyQuoteStorage";
import {getQuoteCreated} from "@api/getQuoteCreated";

interface QuotationProps {
    setLoading: Function;
    isMobile: boolean;
    errorVigencia: boolean;
    validity: string;
}

const useStyles = makeStyles((theme: Theme) => ({
    pago: {
        width: '25%',
    },
}));

export const Quotation: React.FC<QuotationProps> = ({validity, isMobile, setLoading, errorVigencia}) => {
    const history = useHistory();
    const {selectedQuote, setSelectedQuote} = useSelectedQuoteStore();
    const {payment_option, Packages} = useGetQuotePayment();
    const {car} = useCarStore();
    const {driver} = useDriverStore();
    const {token} = useTokenStore();
    const {policy, addPolicyInfo} = usePolicyStore();
    const {tracking} = useTrackingStore();
    const {cpData} = useCPStore();
    const {carList} = useCarListStore();
    const classes = useStyles();
    const [percentageRT, setPercentageRT] = React.useState(0);
    const [percentageDM, setPercentageDM] = React.useState(0);
    const [montoPlus, setMontoTotalPlus] = React.useState('');
    const [openModal, setOpenModal] = React.useState<boolean>(false);
    const {
        //PackagesCopy,
        PaymentOptionCopy,
        addCopyQuoteInfo,
        setPaymentOptionCopy,
        setPackageCopy, removeCopyQuoteInfo
    } = useCopyQuoteStore();
    //const {Packages, payment_option } = useGetQuotePayment();
    const {CopyQuote} = useCopyQuoteStore();
    //const [appear, setAppear] = React.useState<boolean>(false);
    
    React.useEffect(() => {
        const rtCoverage = selectedQuote?.coverages_array?.find(
            (coverage: any) => coverage.code === 'RT'
        );
        const dmCoverage = selectedQuote?.coverages_array?.find(
            (coverage: any) => coverage.code === 'DM'
        );

        rtCoverage && setPercentageRT(rtCoverage.deductive);
        dmCoverage && setPercentageDM(dmCoverage.deductive);
    }, [selectedQuote]);

    const DataLayer = {
        event: 'CSform_step_4_submit',
        eventCategoy: 'Formulario.Seguro.Auto.v2',
        eventAction: 'step_4_submit',
        eventLabel: undefined,
        telefono: driver.telefono,
        correo: driver.email,
        noCotizacion: policy.policyNumber,
        modelo: car.description,
        marca: car.assembler,
        anio: car.model,
        paquete: selectedQuote?.package,
        forma_pago: selectedQuote?.payment_option,
        aseguradora: selectedQuote?.insurance,
        tarjeta: undefined,
        tipo_tarjeta: undefined,
        tipo_vehiculo: car.type,
        colaborador: undefined,
        ecommerce: {
            checkout: {
                actionField: {step: 1, action: 'CSform_step_4_submit'},
                products: [
                    {
                        name: selectedQuote?.insurance,
                        id: undefined, //string
                        price: parseInt(selectedQuote?.insurance_premium?.total), //numero
                        brand:
                            '[paquete:' +
                            selectedQuote?.package +
                            '_pago:' +
                            selectedQuote?.payment_option +
                            ']',
                        category: 'SeguroCoche',
                        variant: car.model,
                        quantity: 1,
                    },
                ],
            },
        },
    };

    const tagManagerArgs = {
        dataLayer: DataLayer,
    };

    const produc_detail = {
        event: 'productDetail',
        eventCategoy: 'Formulario.Seguro.Auto.v2',
        eventAction: 'step_3_submit',
        eventLabel: 'productDetail',
        ecommerce: {
            detail: {
                actionField: {
                    list:
                        '[' +
                        selectedQuote?.insurance +
                        ',' +
                        selectedQuote?.insurance_premium?.total +
                        ']',
                    action: 'productDetail',
                },
                products: [
                    {
                        name: selectedQuote?.insurance,
                        id: undefined,
                        price: selectedQuote?.insurance_premium?.total, //número
                        brand:
                            '[paquete:' +
                            selectedQuote?.package +
                            '_pago:' +
                            selectedQuote?.payment_option +
                            ']',
                        category: 'SeguroCoche',
                        variant: selectedQuote?.vehicle?.model,
                        quantity: 1,
                    },
                ],
            },
        },
    };
    const tagManagerProduct = {
        dataLayer: produc_detail,
    };

    const ValidatePlan = (insurance: any, quoteCopy: any, packagesCopy: any, paymentOptionCopy: any) => {
        if (insurance) {
            if (quoteCopy.package === "AMP") {
                quoteCopy.package = "AMPI";
            }
            addCopyQuoteInfo(quoteCopy)
            setPackageCopy(packagesCopy.label, quoteCopy.package)
            setPaymentOptionCopy(paymentOptionCopy.label, paymentOptionCopy.value)
        }
    }

    const fetchQuoteAI = async () => {
        setLoading(true);
        let percentageRTpivot = percentageRT.toString();
        let percentageDMpivot = percentageDM.toString();

        try {
            const {data} = await getQuoteCreated(
                token,
                tracking.id,
                selectedQuote.insurance,
                driver,
                car,
                cpData[0],
                "AMPI",
                payment_option.value,
                percentageRTpivot,
                percentageDMpivot,
                undefined,
                validity
            );
            await ValidatePlan(data?.data?.insurance, data.data, Packages, payment_option)
            setTimeout(() => {
                setLoading(false);
                setOpenModal(true);
            }, 2000)
        } catch (e) {
            setLoading(false);
            setOpenModal(false);
            console.log(e);
            history.push('/hiring');
        }
    }

    const ValidateAccionButton = () => {
        if (policy?.package_label === 'Plan Amplio') {
            fetchQuoteAI()
        } else {
            goToHiring()
        }

    }
    const goToHiring = () => {
        TagManager.dataLayer(tagManagerArgs);
        TagManager.dataLayer(tagManagerProduct);
        TagManager.dataLayer({
            dataLayer: {
                event: 'cocheapp_seguro_contratar',
                aseguradora: policy.package_new,
                modalidad_pago: policy.payment_new,
                costo_anual: selectedQuote?.insurance_premium?.total,
                Cotizacion: policy.policyNumber,
                boton_contratar: 'Contratar',
            },
        });
        policy.stage = '2. Cotización (Coche)';
        policy.sub_stage = '3. Elección';
        policy.state_code = 'Activa';
        policy.status_code = 'En curso';
        if(CopyQuote){
            CopyQuote.package = 'AMPI';
        }
        // addCopyQuoteInfo({...CopyQuote});
        addCopyQuoteInfo(CopyQuote);
        addPolicyInfo({...policy});
        let initialData = {
            id: tracking.id,
            business: 'cocheseguro',
            data: {
                car: car,
                driver: driver,
                selectedQuote: selectedQuote,
                policy: policy,
                cpData: cpData,
                carList: carList,
            },
        };
        getTracking(token, initialData);
        upCRM(
            token,
            car,
            driver,
            selectedQuote,
            policy,
            tracking,
            cpData,
            selectedQuote
        );

        history.push('/hiring');
    };

    let totalNumber = 0;
    selectedQuote?.receipts?.map((item: any) => {
        const number = Number(item?.total_premium);
        totalNumber += number;
    });

    let totalPayment = totalNumber.toString();
    const [attach, setAttach] = useState(false);
    let totalNumberCopy = 0;
    selectedQuote?.receipts?.map((item: any) => {
        const number = Number(item?.total_premium);
        totalNumberCopy += number;
    });
    const {clamp} = useClamp();

    onscroll = (e: any) => {
        window.scrollY >= 840 ? setAttach(true) : setAttach(false);
    };
    let insurer: string = selectedQuote?.insurance.toLocaleUpperCase();
    let div = 12;
    if( policy.payment_label === 'Anual'){
        div= 1;
    }
    if( policy.payment_label === 'Mensual'){
        div= 12;
    }
    if( policy.payment_label === 'Trimestral'){
        div= 4;
    }
    if( policy.payment_label === 'Semestral'){
        div= 2;
    }
        let proteccionPlus = 0;
        let proteccionPlusM = 0;
        let montoTotal = 0;
    if (policy.payment_label === 'Anual'){
        proteccionPlus = parseFloat(CopyQuote?.receipts[0]?.total_premium)  - parseFloat(selectedQuote?.receipts[0]?.total_premium);
        proteccionPlusM = parseFloat(CopyQuote?.receipts[0]?.total_premium)  - totalNumberCopy;
        montoTotal = parseFloat(CopyQuote?.receipts[0]?.total_premium);
    
    } else{
        proteccionPlus = parseFloat(CopyQuote?.receipts[0]?.total_premium) + (parseFloat(CopyQuote?.receipts[1]?.total_premium) * (div-1)) - parseFloat(selectedQuote?.receipts[0]?.total_premium);
        proteccionPlusM = parseFloat(CopyQuote?.receipts[0]?.total_premium) + (parseFloat(CopyQuote?.receipts[1]?.total_premium) * (div-1))  - totalNumberCopy;
        montoTotal = parseFloat(CopyQuote?.receipts[0]?.total_premium) + (parseFloat(CopyQuote?.receipts[1]?.total_premium) * (div-1));
    }
    let pagoMes = proteccionPlusM / div;
    let pagoAnual = proteccionPlus / div;

    function handleClickNo() {
        setOpenModal(false)
        removeCopyQuoteInfo()
        history.push('/hiring');
    }

    function handleClickAgregar() {
        setOpenModal(false)
        //addQuoteInfo(quoteCopy)
        setSelectedQuote(CopyQuote)
        history.push('/hiring');
    }

    return (
        <>
            <Box
                flexDirection={'row'}
                alignItems={'center'}
                justifyContent={'space-between'}
                position={'relative'}
                style={{
                    backgroundColor: 'white',
                    padding: clamp('16px 150px 0 10px', '24px 40px', '24px 8px'),
                    marginTop: '5px',
                }}
            >
                <OrderSelect icon={selectedInsurer.logo} name={selectedInsurer.name}/>
                <Box
                    margin="0px 0px 20px 0px"
                    sx={{
                        display: 'flex',
                    }}
                >
                    <Typography fontWeight="700" fontSize="20px">
                        Total a pagar
                    </Typography>
                    <Info
                        color="primary"
                        data-for="pago"
                        data-tip=""
                        data-iscapture="true"
                        sx={{cursor: 'pointer', marginLeft: '20px'}}
                    />
                    <ReactTooltip
                        id="pago"
                        type="light"
                        place="bottom"
                        backgroundColor="#EBF8FB"
                        className={classes.pago}
                    >
                        <Box
                            padding={2}
                            marginTop={2}
                            borderRadius={2}
                            style={{backgroundColor: '#EBF8FB'}}
                        >
                            <Typography textAlign={'start'} fontWeight={'normal'} fontSize={13}>
                                El primer pago es más elevado debido al costo de la emisión de la
                                poliza
                            </Typography>
                        </Box>
                    </ReactTooltip>
                </Box>
                <Typography
                    fontWeight="400"
                    fontSize="14px"
                    sx={{
                        marginBottom: '20px',
                    }}
                >
                    Cobertura {policy.package_label}
                </Typography>
                {policy.payment_label === 'Anual' ? (
                    <Box display="flex" justifyContent="space-between">
                        <Typography
                            sx={{
                                margin:
                                    policy.payment_label === 'Anual' ? '0px 0px 20px 0px' : 'unset',
                            }}
                            fontWeight="400"
                            fontSize="14px"
                        >
                            Único pago de
                        </Typography>
                        <Typography fontWeight="600" fontSize="16px">
                            $
                            {parseFloat(parseFloat(totalPayment).toFixed(2)).toLocaleString(
                                'es-MX',
                                {minimumFractionDigits: 2}
                            )}
                        </Typography>
                    </Box>
                ) : (
                    <Payment
                        paymentMode={policy.payment_label}
                        payResults={selectedQuote?.receipts}
                    />
                )}
                {policy.package_label === 'Plan Amplio' ? (
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        margin="0px 0px 20px 0px"
                    >
                        <Typography fontWeight="400" fontSize="14px">
                            Porcentaje de Daños Materiales
                        </Typography>
                        <Typography
                            fontWeight="600"
                            fontSize="16px"
                        >{`${percentageDM}%`}</Typography>
                    </Box>
                ) : null}
                {policy.package_label !== 'Plan Basico' ? (
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        margin="0px 0px 20px 0px"
                    >
                        <Typography fontWeight="400" fontSize="14px">
                            Porcentaje de Robo Total
                        </Typography>
                        <Typography
                            fontWeight="600"
                            fontSize="16px"
                        >{`${percentageRT}%`}</Typography>
                    </Box>
                ) : null}
                <TotalPayment payment={totalPayment} payment_option={payment_option}/>
                <CustomButton
                    onClick={ValidateAccionButton}
                    disabled={errorVigencia}
                    color={'primary'}
                    variant={'contained'}
                    text="¡SÍ LO QUIERO!"
                    style={{
                        height: 56,
                        width: isMobile && attach ? '85%' : '100%',
                        textTransform: 'none',
                        bottom: isMobile && attach ? 70 : 'unset',
                        left: isMobile && attach ? 34 : 'unset',
                        position: isMobile && attach ? 'fixed' : 'relative',
                        zIndex: '1000',
                    }}
                />
            </Box>
            <GenericModal
                open={openModal}
                setOpenModal={setOpenModal}
                title='¿Quieres protección adicional?'
                cardTitle={'Protección Plus'}
                titleCheck={'Agregar'}
                pagoMes={PaymentOptionCopy.label === 'Anual' ? pagoAnual.toString() : pagoMes.toString()}
                textCobertura='Cobertura amplia: '
                montoCobertura={PaymentOptionCopy.label === 'Anual' ? selectedQuote?.receipts[0]?.total_premium : totalNumberCopy}
                textTotalPlus='Total Protección Plus:'
                montoTotalPlus={PaymentOptionCopy.label === 'Anual' ? proteccionPlus.toString() : proteccionPlusM.toString()}
                textPrimerPago={PaymentOptionCopy.label !== 'Anual' ? 'Primer pago de:' : ''}
                montoPrimerPago={PaymentOptionCopy.label !== 'Anual' ? CopyQuote?.receipts[0]?.total_premium : ''}
                textMasPagos={PaymentOptionCopy.label === 'Semestral' ? 'Más un pago de:' : `Más ${CopyQuote?.receipts?.length - 1} pagos de:`}
                montoMasPagos={CopyQuote?.receipts[1]?.total_premium}
                textCostoAnual='Costo anual:'
                montoCostoAnual={montoTotal.toString()}
                data={insurer ? getInsurers(insurer) : []}
                appear={PaymentOptionCopy.label !== 'Anual' ? 'true' : 'false'}
                onClickNo={handleClickNo}
                onClickAgregar={handleClickAgregar}
            />


        </>
    );
};

export const Payment = ({paymentMode, payResults}: any) => {
    if (paymentMode === 'Anual') return null;
    return (
        <Box
            display="flex"
            justifyContent="space-between"
            margin="0px 0px 20px 0px"
        >
            <Typography fontWeight="400" fontSize="14px">
                Primer pago de
                <ul
                    style={{
                        margin: 0,
                    }}
                >
                    <li style={{color: '#8F8F8F', fontWeight: 400}}>
                        {paymentMode === 'Semestral'
                            ? 'Más un pago de'
                            : `Más ${payResults.length - 1} pagos de`}
                    </li>
                </ul>
            </Typography>
            <Typography fontWeight="600" fontSize="16px">
        <span style={{marginLeft: '19px'}}>
          + $
            {parseFloat(
                parseFloat(payResults[0].total_premium).toFixed(2)
            ).toLocaleString('es-MX', {
                minimumFractionDigits: 2,
            })}
        </span>
                <ul
                    style={{
                        margin: 0,
                    }}
                >
                    <div
                        style={{
                            color: '#8F8F8F',
                            fontWeight: 400,
                            fontSize: 14,
                        }}
                    >
                        + $
                        {parseFloat(
                            parseFloat(
                                payResults[1]
                                    ? payResults[1].total_premium
                                    : payResults[0].total_premium
                            ).toFixed(2)
                        ).toLocaleString('es-MX', {
                            minimumFractionDigits: 2,
                        })}
                    </div>
                </ul>
            </Typography>
        </Box>
    );
};

export const TotalPayment = ({payment, payment_option}: any) => {
    let isMobile = false;
    return (
        <>
            <Box
                display="flex"
                justifyContent="space-between"
                margin={`${!isMobile ? '25px 0px 15px' : '25px 0px 30px'}}`}
            >
                <Typography>Costo anual:</Typography>
                <Typography fontSize="20px" fontWeight="700">
                    $
                    {parseFloat(parseFloat(payment).toFixed(2)).toLocaleString('es-MX', {
                        minimumFractionDigits: 2,
                    })}
                </Typography>
            </Box>
            <Box
                sx={{
                    backgroundColor: '#F2F5F7',
                    // padding: '7px 14px 9px 15px',
                    paddingLeft: '7px',
                    paddingTop: '14px',
                    paddingRight: '9px',
                    paddingBottom: '15px',
                    marginBottom: '18px',
                    borderRadius: '8px',
                }}
            >
                <Typography sx={{fontWeight: 'bold', fontSize: '14px'}}>
                    ¡Importante!
                </Typography>
                <Typography sx={{fontSize: '12px'}}>
                    <b>
                        Esta aseguradora renovará y cobrará tu seguro en automático cada
                        año.
                    </b>
                    ¡Claro que en Inter te recordaremos siempre tu fecha de renovación
                    para que no te caiga de sorpresa!. Si quieres cancelar tu seguro,
                    basta con una llamada al <b>55 442 46837</b> hasta un mes antes de la
                    renovación.
                </Typography>
            </Box>
        </>
    );
};
